module.exports = __webpack_public_path__ + "static/media/play-score-1.d1767c0d.png";